import React from "react";
import PeakFlowImage from "../../../public/media/icons/icon_lungs.png";
import {$$} from "../../helpers/localization";

export class PeakFlowIcon extends React.Component {
    render() {
        return <img src={PeakFlowImage} alt={$$("peak_flow")} {...this.props} />
    }
}